<template>
  <div class="login_bimg">
    <div class="header">
      <div class="logo-wrapper">
        <img src="../../static/img/logo_yt.svg" class="logo" />
        <span class="title">燕通检车平台</span>
      </div>
      <a href="/static/download/ChromeSetup.exe" class="download-link"
        >下载谷歌浏览器</a
      >
    </div>

    <div class="login-card">
      <div class="login-title">
        <span>账户登录</span>
        <div class="title-line"></div>
      </div>

      <div class="login-form">
        <div class="input-group">
          <label class="input-label">用户名</label>
          <input
            placeholder="请输入用户名"
            v-model="userName"
            :class="['login-input', Inputactive1]"
            @focus="Inputactive1 = 'input-focus'"
            @blur="Inputactive1 = ''"
          />
        </div>
        <div class="input-group">
          <label class="input-label">密码</label>
          <input
            type="password"
            placeholder="请输入密码"
            @keyup.enter="login"
            v-model="password"
            :class="['login-input', Inputactive]"
            @focus="Inputactive = 'input-focus'"
            @blur="Inputactive = ''"
            autocomplete="off"
          />
        </div>
        <div class="input-group" v-if="showValidateCode">
          <label class="input-label">验证码</label>
          <div class="captcha-row">
            <input
              placeholder="请输入验证码"
              @keyup.enter="login"
              v-model="validateCode"
              :class="['login-input', Inputactive2]"
              @focus="Inputactive2 = 'input-focus'"
              @blur="Inputactive2 = ''"
              autocomplete="off"
            />
            <img
              :src="validateCodeBase64"
              class="validate-code"
              @click="getValidateCodeImg()"
            />
          </div>
        </div>
        <div class="checkbox-wrapper">
          <el-checkbox
            v-model="rememberUser"
            label="rememberuser"
            class="remember-checkbox"
            >记住用户</el-checkbox
          >
        </div>
        <el-button :class="btnClass" @click.native="login" class="login-btn"
          >登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</el-button
        >
      </div>
    </div>

    <TipMsgDialog
      :userOptions="tipOptions"
      @tipMsgOK="tigMsgInfo()"
      @tipMsgClose="tipMsgCancel()"
      @tipMsgCancel="tipMsgCancel()"
      v-if="tipOptions.visible"
    ></TipMsgDialog>
    <el-dialog
      title="重要通知，请注意收看"
      :visible.sync="dialogNotifyVisible"
      width="60%"
    >
      <div>
        <h2>
          1、旧域名“yantong.huayantech.cn”即将停用，请大家使用“https://yantong.zemichykj.com/”访问系统，您需要重新安装打印报表控件,否则打印报表功能无法正常使用。请卸载原打印控件，安装新版打印控件。
        </h2>
      </div>
      <div>
        <h2>
          2、对于使用预检小票打印监控小程序的用户,请在监控小程序的“设置”选项卡里将服务地址改为“https://yantong.zemichykj.com/api/”，设置保存完毕后关掉重新打开打印监控小程序。
          <br /><img src="@static/img/sz01.png" width="600" />
        </h2>
      </div>
      <p>
        <a
          href="static/download/PrintClient.msi"
          style="font-size: 20px; color: red"
          ><b>=>点击下载新版打印控件</b></a
        >
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogNotifyVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="version">
      版本号：V1.2.1.20231107.YT<span style="display: none"
        >冀ICP备15001061号-3</span
      >
    </div>
  </div>
</template>

<script>
// import PasswordDialog from "./password";
import { InitAll } from "@/js/DropDownList.js";
// import wxlogin from "vue-wxlogin";
//读取敏感词配置文件
import { sensitiveWordsArray } from "@/js/globalConfig.js";
export default {
  data() {
    return {
      rememberUser: false,
      checkedItem: [],
      activeName: "userlogin",
      userType: 0,
      OwnedStationCode: "",
      showDialog: false,
      tipOptions: {
        showType: 0,
        visible: false,
        showDesp: true,
        btnTitle: "确 定",
        msg: "是否删除此条数据？",
        desp: "删除后不可恢复。",
        showCancelBtn: true,
      },
      tipFlag: 0,
      dialogTitle: "",
      bg: {},
      rememberPassword: false,
      autologin: false,
      userName: "",
      password: "",
      validateCode: "",
      Inputactive: "",
      Inputactive1: "",
      Inputactive2: "",
      promptInfo: "",
      loading: null,
      btnClass: "login_btn login_btn_color",
      //图片验证码src
      validateCodeBase64: "",
      //客户端uuid，用于判断验证码
      clientUUID: "",
      //weChatAPPID: "",
      //weChatRedirectURL: "",
      //weChatState: "",
      //weChatScope: "",
      dialogVisible: false,
      //weChatToken: "",
      //weChatUserInfo: null,
      //weChatUserInfoSelected: "",
      showValidateCode: true,
      showWeChat: false,
      dialogNotifyVisible: false,
    };
  },
  mounted() {},
  beforeCreate: function () {},
  created() {
    // this.getWeChatInfo().then(() => {
    //   //this.showWeChat = true;
    //生成客户端uuid
    this.clientUUID = this.rnd(1000000000, 9999999999);
    console.log("test");
    //获取验证码base64图片
    this.getValidateCodeImg();
    // });
    let rememberUser = localStorage.getItem("rememberUser");
    if (rememberUser == undefined || rememberUser == null) {
      this.rememberUser = false;
    } else {
      this.rememberUser = true;
      this.userName = rememberUser;
    }
    console.log(rememberUser);
  },
  beforeDestroy: function () {
    document.onkeydown = function (e) {};
  },
  // components: {
  //   PasswordDialog: PasswordDialog,
  //   wxlogin: wxlogin,
  // },
  methods: {
    // getWeChatInfo() {
    //   return new Promise((resolve, reject) => {
    //     this.$axios
    //       .post("/WeChatLogin/GetWeChatSettingInfo", {})
    //       .then((res) => {
    //         if (res.data.Code == "10000") {
    //           this.weChatAPPID = res.data.Data.AppId;
    //           this.weChatRedirectURL = res.data.Data.Redirect_Uri;
    //           this.weChatState = res.data.Data.State;
    //           this.weChatScope = res.data.Data.Scope;

    //           resolve();
    //         } else {
    //           reject();
    //         }
    //       })
    //       .catch((err) => {
    //         reject();
    //       });
    //   });
    // },
    //获取验证码图片
    getValidateCodeImg() {
      this.$axios
        .post("/Login/GetValidateImg", {
          uuid: this.clientUUID,
        })
        .then((res) => {
          this.validateCodeBase64 = "data:image;base64," + res.data.Data;
        });
    },

    tigMsgInfo: function () {
      this.tipOptions.visible = false;
      if (this.tipOptions.showCancelBtn == true) {
        if (this.tipFlag == 1) {
          this.dialogTitle = "修改密码";
          this.promptInfo = "";
          this.showDialog = true;
          this.$refs.OpenDialog.getPasswordRule();
        }
      }
    },
    tipMsgCancel: function () {
      this.tipOptions.visible = false;
      if (this.tipFlag == 1) {
        this.getAuthToken();
      }
    },
    dialogClose(visible) {
      this.showDialog = visible;
    },
    login() {
      //按钮灰色不能点击
      if (this.btnClass == "login_btn login_btn_color") {
        return;
      }
      if (this.showValidateCode && !this.validateCode) {
        this.$message.error("请输入验证码！");
        return;
      }
      if (!this.userName) {
        this.$message.error("请输入用户名！");
        return;
      } else if (!this.password) {
        this.$message.error("请输入密码！");
        return;
      } else {
        this.loading = this.$loading({
          lock: true,
          text: "正在登录...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        this.loginChecker();
        // this.rememberPasswordAndAutoLogin();
      }
    },
    rnd(n, m) {
      var random = Math.floor(Math.random() * (m - n + 1) + n);
      return random;
    },
    loginChecker() {
      this.$axios
        .post("/Login/LoginCheck", {
          username: this.userName,
          password: this.password,
          validateCode: this.validateCode,
          uuid: this.clientUUID,
        })
        .then(
          function (res) {
            //检查
            if (res.data.Code == "10000") {
              this.getAuthToken();
            } else if (res.data.Code == "10009") {
              if (this.loading) this.loading.close();
              this.$message.warning(res.data.Message || "所属检测站授权已到期，请联系当地销售经理或拨打客服电话进行系统授权");
              // 先获取Token，以便授权页面可以调用检测站信息和授权信息接口
              this.getAuthTokenForAuth();
            } else {
              if (this.loading) this.loading.close();
              if (res.data.Code == "10005") {
                this.showValidateCode = true;
              }
              this.validateCode = "";
              this.getValidateCodeImg();
              this.$message.error(res.data.Message);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            if (this.loading) this.loading.close();
            if (
              err.response.status == undefined ||
              err.response.status == null
            ) {
              this.$message.error("服务端连接错误！");
            } else if (err.response.status == 504) {
              this.$message.error("网络连接超时，请检查网络连接是否异常！");
            } else {
              this.$message.error("服务端错误！");
            }
          }.bind(this)
        );
    },
    getAuthTokenForAuth() {
      // 授权到期时：获取Token和UserInfo后跳转授权页面
      this.loading = this.$loading({
        lock: true,
        text: "正在获取授权信息...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post("/OAuth/Token", {
          grant_type: "password",
          Username: this.userName,
          Password: this.password,
        })
        .then((res) => {
          this.$store.dispatch("user/savetoken", res.data.access_token);
          // 尝试获取UserInfo（路由守卫需要），失败不删token
          this.getUserInfoForAuth();
        })
        .catch((err) => {
          if (this.loading) this.loading.close();
          if (err.response && err.response.status == 504) {
            this.$message.error("网络连接超时，请检查网络连接是否异常！");
          } else if (err.response && err.response.status) {
            this.$message.error("获取授权信息失败，请重试");
          } else {
            this.$message.error("服务端连接错误！");
          }
        });
    },
    getUserInfoForAuth() {
      // 获取用户基本信息，失败时保存最小用户信息以通过路由守卫
      this.$axios
        .post("/Login/GetLoginUser", {})
        .then((res) => {
          if (this.loading) this.loading.close();
          if (res.data.Code == "10000") {
            this.$store.dispatch("user/saveuser", res.data.Data);
          } else {
            // 获取UserInfo失败，存最小信息以通过路由守卫
            sessionStorage.setItem("userInfo", JSON.stringify({ UserName: this.userName }));
          }
          this.$router.push("/permission/modiAuth");
        })
        .catch(() => {
          if (this.loading) this.loading.close();
          // 接口异常，存最小信息以通过路由守卫
          sessionStorage.setItem("userInfo", JSON.stringify({ UserName: this.userName }));
          this.$router.push("/permission/modiAuth");
        });
    },
    getAuthToken() {
      //console.log(this.userName + "," + this.password)
      this.$axios
        .post("/OAuth/Token", {
          grant_type: "password",
          Username: this.userName,
          Password: this.password,
        })
        .then((res) => {
          //获取用户信息
          this.$store.dispatch("user/savetoken", res.data.access_token);
          this.getUserInfo();
        })
        .catch((err) => {
          if (this.loading) this.loading.close();
          if (err.response.status == undefined || err.response.status == null) {
            this.$message.error("服务端连接错误2！");
          } else if (err.response.status == 504) {
            this.$message.error("网络连接超时，请检查网络连接是否异常！");
          } else {
            this.$message.error("用户名密码错误，或该账号已被禁用");
            this.$store.dispatch("user/removetoken");
          }
        });
    },
    getUserInfo() {
      this.$axios
        .post("/Login/GetLoginUser", {})
        .then((res) => {
          if (res.data.Code == "10000") {
            this.$store.dispatch("user/saveuser", res.data.Data);
            if (this.rememberUser) {
              localStorage.setItem("rememberUser", this.userName);
            } else {
              localStorage.removeItem("rememberUser");
            }
            this.userType = res.data.Data.UserType;
            this.OwnedStationCode = res.data.Data.OwnedStationCode;
            //加载下拉菜单项，存入store
            //InitAll(this.userType, this.OwnedStationCode);
            sensitiveWordsArray();

            //进入主界面
            this.$router.push(
              { name: "平台主页" },
              () => {
                if (this.loading) this.loading.close();
              },
              () => {
                if (this.loading) this.loading.close();
              }
            );
          } else {
            if (this.loading) this.loading.close();
            this.$store.dispatch("user/removetoken");
            this.$store.dispatch("user/removeuser");
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          if (this.loading) this.loading.close();
          if (err.response.status == undefined || err.response.status == null) {
            this.$message.error("服务端连接错误！");
          } else if (err.response.status == 504) {
            this.$message.error("网络连接超时，请检查网络连接是否异常！");
          } else {
            this.$message.error("获取用户信息错误！");
            this.$store.dispatch("user/removetoken");
            this.$store.dispatch("user/removeuser");
          }
        });
    },
    //初始化系统字典
    InitSysDic() {
      this.$store.dispatch("user/LoadVehicleType"); // 车辆类别
    },
  },
  watch: {
    userName: {
      handler: function () {
        if (this.userName != "" && this.password != "") {
          this.btnClass = "login_btn login_btn_color_focus";
        } else {
          this.btnClass = "login_btn login_btn_color";
        }
      },
    },
    password: {
      handler: function () {
        if (this.userName != "" && this.password != "") {
          this.btnClass = "login_btn login_btn_color_focus";
        } else {
          this.btnClass = "login_btn login_btn_color";
        }
      },
    },
  },
};
</script>

<style scoped>
input,
button {
  font-family: "Microsoft Yahei", Helvetica, Arial, "sans-serif";
}
body {
  color: #555;
  font-family: "Microsoft Yahei", Helvetica, Arial, "sans-serif" !important;
}

.login_bimg {
  background-image: url(../assets/login_bg_new.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 40px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
}

.title {
  font-size: 30px;
  font-weight: bold;
  color: #333;
}

.download-link {
  font-size: 14px;
  color: #fff;
  text-decoration: none;
}

.login-card {
  position: absolute;
  right: 145px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 36px 32px;
  width: 340px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.login-title {
  text-align: center;
  margin-bottom: 28px;
  margin-top: 28px;
}

.login-title span {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.title-line {
  width: 40px;
  height: 3px;
  background: #2b7fff;
  border-radius: 2px;
  margin: 10px auto 0;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.input-group {
  margin-bottom: 16px;
}

.input-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.login-input {
  padding: 12px 16px;
  font-size: 15px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fafafa;
  margin-bottom: 0;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s, background-color 0.3s;
}

.login-input:focus {
  outline: none;
  border-color: #2b7fff;
  background: #fff;
}

.login-input::placeholder {
  color: #bbb;
}

.input-focus {
  border-color: #2b7fff !important;
  background: #fff !important;
}

.captcha-row {
  display: flex;
  align-items: center;
}

.captcha-row .login-input {
  flex: 1;
  width: auto;
  margin-bottom: 0;
}

.validate-code {
  width: 84px;
  height: 42px;
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fafafa;
  flex-shrink: 0;
}

.checkbox-wrapper {
  margin-top: 6px;
  margin-bottom: 20px;
}

.remember-checkbox {
  font-size: 12px;
  color: #666;
}

.login-btn {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  margin-bottom: 64px;
}

.login_btn_color {
  background: #e8eef4;
  color: #999;
  cursor: not-allowed;
}

.login_btn_color_focus {
  background: #2b7fff;
  color: #fff;
  cursor: pointer;
}

.version {
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  color: #999;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue